<template>
    <div class="images-list">
        <div v-if="isPreview" slot="tip" class="el-upload__tip"> <i class="el-icon-warning-outline"></i> 点击文件名称可下载文件
        </div>
        <el-upload class="upload-demo" action="#" ref="upload" :accept="acceptParm" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-remove="beforeRemove" :multiple="fileLimit > 1" :limit="fileLimit"
            :list-type="listType" :on-exceed="handleExceed" :file-list="fileList" :http-request="handleFileUpload">
            <!-- <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                将文件拖到此处，或 <em>点击选取</em>
            </div> -->
            <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
    </div>
</template>
<script>
import { Upload, SaveSingleAttachment } from '../api/systemApi.js';

function MyDebounce(fn, duration = 100) {
    let timer = null;
    return (...arg) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn.call(this, ...arg);
        }, duration)
    }
}
export default {
    name: 'chunkUpload',
    props: {
        // 值
        value: [String, Object, Array],
        // 是否点击下载
        isPreview: {
            type: Boolean,
            default: false
        },
        // 最大允许上传个数
        fileLimit: {
            type: Number,
            default: 99,
        },
        // 上传文件格式
        acceptParm: {
            type: String,
            default: '.png,.jpg,.jpeg',
        },
        // 文件列表类型 text/picture/picture-card
        listType: {
            type: String,
            default: 'text',
        },
    },
    data() {
        return {
            loading: false,
            fileList: [], //深拷贝，判断重名及第一步时的文件信息展示
            load: null,
            loadingNum: 0,
            tempFileList: [],
        };
    },
    watch: {
        value: {
            handler: function (newVal, oldVal) {
                this.tempFileList = newVal;
            },
            immediate: true,
            deep: true,
        },
    },
    created() {
        this.fileList = JSON.parse(JSON.stringify(this.value));
    },
    methods: {
        async handleFileUpload(fileValue) {
            // loading次数   避免多个上传时loading提前关闭
            this.loadingNum += 1
            this.load = this.$loading({
                lock: true,
                text: '文件上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)'
            });
            let file, chunks, fileIdentifier, uploadList;
            file = fileValue.file;
            chunks = this.splitFile(file);
            uploadList = []
            fileIdentifier = Date.now().toString(); // 简单的文件标识符

            /* 1. 获取本地存储的文件上传列表
               2. 看是否为上传中断文件
            */
            let uploadHalfList = JSON.parse(localStorage.getItem('uploadHalfList')) || []
            uploadHalfList.map(item => {
                // 文件名相同 文件大小相同
                if (item.fileName === file.name && item.fileSize === file.size) {
                    let array = this.getUploadHistory(item, chunks)
                    uploadList = array[0]
                    fileIdentifier = array[1]
                }
            });
            // 非上传中断文件   更新上传切片列表
            if (uploadList.length === 0) {
                uploadList = this.uploadFileList(chunks)
                let fileObj = {
                    fileName: file.name,
                    fileSize: file.size,
                    fileTypeId: fileIdentifier,
                    chunks: chunks.length,
                    allUpload: false,
                    lastChunkIndex: 0,
                    errList: []
                }
                uploadHalfList.push(fileObj)
            }
            // 上传时候保存文件信息
            localStorage.setItem('uploadHalfList', JSON.stringify(uploadHalfList));
            for (let i = 0; i < chunks.length; i++) {
                let percent = ((i + 1) / chunks.length * 100 | 0) + '%'
                this.load.setText('文件上传中，' + percent + '...');
                const chunk = chunks[i];
                const formData = new FormData();
                formData.append('file', chunk);
                let queryData = {
                    FileTypeId: fileIdentifier,
                    fileName: file.name,
                    chunkIndex: i,
                    totalChunks: chunks.length,
                }
                if (uploadList.includes(i) && i !== chunks.length - 1) {
                    //按顺序执行接口
                    await Upload(formData, queryData).then(res => {
                        //记录一下成功的 最后一条
                        let uploadHalfList = JSON.parse(localStorage.getItem('uploadHalfList'))
                        uploadHalfList.forEach(item => {
                            // 文件名相同 文件大小相同
                            if (item.fileName === file.name && item.fileSize === file.size) {
                                item.lastChunkIndex = i
                            }
                        });
                        localStorage.setItem('uploadHalfList', JSON.stringify(uploadHalfList));
                    }).catch((err) => {
                        // 记录失败切片索引
                        let uploadHalfList = JSON.parse(localStorage.getItem('uploadHalfList'))
                        uploadHalfList.forEach(item => {
                            // 文件名相同 文件大小相同
                            if (item.fileName === file.name && item.fileSize === file.size) {
                                item.errList.push(i)
                            }
                        });
                        localStorage.setItem('uploadHalfList', JSON.stringify(uploadHalfList));
                    })
                }
                if (i === chunks.length - 1) {
                    let uploadHalfList = JSON.parse(localStorage.getItem('uploadHalfList'))
                    uploadHalfList.forEach(item => {
                        // 文件名相同 文件大小相同 
                        if (item.fileName === file.name && item.fileSize === file.size) {
                            if (item.errList.length === 0) {
                                Upload(formData, queryData).then(res => {
                                    this.overUpload(file, fileIdentifier)
                                    this.loadingNum = this.loadingNum - 1
                                    if (this.loadingNum === 0) {
                                        this.load.close();
                                    }
                                }).catch((err) => {
                                    // 记录失败切片索引
                                    let uploadHalfList = JSON.parse(localStorage.getItem('uploadHalfList'))
                                    uploadHalfList.forEach(item => {
                                        // 文件名相同 文件大小相同
                                        if (item.fileName === file.name && item.fileSize === file.size) {
                                            item.errList.push(i)
                                        }
                                    });
                                    localStorage.setItem('uploadHalfList', JSON.stringify(uploadHalfList));
                                    this.loadingNum = this.loadingNum - 1
                                    if (this.loadingNum === 0) {
                                        this.load.close();
                                    }
                                })
                            } else {
                                this.$message.info('有文件切片未成功上传，请再次上传文件！')
                                this.loadingNum = this.loadingNum - 1
                                if (this.loadingNum === 0) {
                                    this.load.close();
                                }
                            }
                        }
                    });

                }
            }
        },
        // 上传结束
        overUpload(file, fileIdentifier) {
            // 最后一块传完之后看是否有失败的块
            let a = JSON.parse(localStorage.getItem('uploadHalfList'))
            let b = {}
            let bIndex = 0
            a.forEach((item, index) => {
                // 文件名相同 文件大小相同
                if (item.fileName === file.name && item.fileSize === file.size) {
                    b = item
                    bIndex = index
                }
            });
            if (b.errList.length === 0) {
                a.splice(bIndex, 1)
                this.$nextTick(() => {
                    this.saveFile(file, fileIdentifier)
                })
            } else {
                this.$message.error('上传完成，有部分未成功上传，请再次上传文件')
            }
            localStorage.setItem('uploadHalfList', JSON.stringify(a));
        },
        // 获取上传历史
        getUploadHistory(fileUploadValue, chunks) {
            let arr = []
            let fileIdentifier = ''
            // 未上传完成或有上传失败部分
            if (fileUploadValue.allUpload === false) {
                fileIdentifier = fileUploadValue.fileTypeId
                // 上传错误列表为空  继续上传
                if (fileUploadValue.errList.length === 0) {
                    for (let i = fileUploadValue.lastChunkIndex + 1; i < chunks.length; i++) {
                        arr.push(i);
                    }
                } else {
                    // 上传错误列表不为空  已上传部分小于总长度  合并错误部分
                    if (fileUploadValue.lastChunkIndex < chunks.length - 1) {
                        for (let i = fileUploadValue.lastChunkIndex + 1; i < chunks.length; i++) {
                            arr.push(i);
                        }
                    }
                    arr = Array.from(new Set(arr.concat(fileUploadValue.errList)))
                }
            } else {
                return
            }
            return [arr, fileIdentifier]
        },
        // 获取文件列表
        uploadFileList(chunks) {
            const arr = [];
            for (let i = 0; i < chunks.length; i++) {
                arr.push(i);
            }
            return arr;
        },
        splitFile(file, chunkSize = 10 * 1024 * 1024) {
            const chunks = [];
            for (let i = 0; i < file.size; i += chunkSize) {
                chunks.push(file.slice(i, i + chunkSize));
            }
            return chunks;
        },
        // 处理移除操作
        handleRemove(file, fileList) {
            this.tempFileList = JSON.parse(JSON.stringify(fileList))
            this.$emit('input', this.tempFileList);
        },
        // 下载文件
        downFile: MyDebounce((file) => {
            let ShowUrl = localStorage.getItem('filePath') + file.url
            const x = new window.XMLHttpRequest();
            x.open('GET', ShowUrl, true);
            x.responseType = 'blob';
            x.onload = () => {
                const url = window.URL.createObjectURL(x.response);
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank'
                a.download = file.name;
                a.style.display = 'none'
                document.body.append(a)
                a.click();
            };
            x.send();
        }, 500),
        // 处理预览操作
        handlePreview(file) {
            if (this.isPreview) {
                this.downFile(file)
            }
        },
        // 处理超出图片个数操作
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 ${this.fileLimit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        // 移除之前的操作
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },
        saveFile(file, fileIdentifier) {
            let postFix = file.name.split('.')[file.name.split('.').length - 1]
            let params = {
                fileName: file.name,
                postFix: postFix,
                fileTypeId: fileIdentifier,
                fileSize: file.size,
            }
            SaveSingleAttachment(params).then(res => {
                if (res.code === 1) {
                    this.$message.success('文件上传成功！')
                    let tempItem = {
                        name: res.data.fileName,
                        url: res.data.filePath,
                        keyId: res.data.keyId,
                        size: res.data.fileSize,
                        createTime: res.data.createTime
                    };
                    this.tempFileList.push(tempItem)
                    this.$emit('input', this.tempFileList);
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(err => {
                this.$message.error('文件上传失败！')
            })
        }
    }
}
</script>
<style scoped>
.images-list {
    border: 1px dashed #d5d5d5;
    padding: 10px;
    border-radius: 4px;
    background: #fff;
    width: 95%;
}

.el-upload__tip {
    line-height: 20px;
    margin: 0;
}
</style>